function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function assignRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    } else if ((typeof ref === "undefined" ? "undefined" : _type_of(ref)) === "object" && ref !== null && "current" in ref) {
        ref.current = value;
    }
}
export { assignRef }; //# sourceMappingURL=assign-ref.js.map
